import { render } from "./Favourites.vue?vue&type=template&id=acdbcc64"
import script from "./Favourites.vue?vue&type=script&lang=js"
export * from "./Favourites.vue?vue&type=script&lang=js"
script.render = render

export default script